import React from 'react';
import PropTypes from 'prop-types';
import { Text, TouchableOpacity, StyleSheet } from 'react-native-web';

import Colors from '../../constants/Colors';
import { onFileRead } from "../../helpers/onFileRead";
import { UserAvatar } from '../../components';

class UserAvatarEdit extends React.Component {
	render() {
		return(
			<label htmlFor='invisibleInput'>
				<TouchableOpacity style={styles.touchContainer}>
					<input
						type='file'
						id='invisibleInput'
						onChange={ e => onFileRead(e, this.props.onImageDataChange)}
						accept='image/png, image/jpeg'
						style={{ display: 'none' }}
					/>

					<UserAvatar
						userName={this.props.userName}
						userAvatarColor={this.props.userAvatarColor}
						userAvatarUri={this.props.userAvatarUri}
						avatarPropsStyle={this.props.avatarPropsStyle}
					/>
					<Text style={styles.textStyle} >
						{ 'Aperte para selecionar nova imagem de perfil' }
					</Text>
				</TouchableOpacity>
			</label>
		)
	}
}

const styles = StyleSheet.create({
    touchContainer: {
        marginTop: 30,
        marginBottom: 30,
        alignItems: 'center'
    },
    textStyle: {
        textAlign: 'center',
        fontSize: 16,
        color: Colors.inputFontColor,
        marginTop: 10
    }
});

UserAvatarEdit.propTypes = {
    onImageDataChange: PropTypes.func.isRequired
};

export { UserAvatarEdit };